(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-product-root]');
    const form = root?.querySelector('.product-form');
    const data = document.querySelector('[data-product-variants]');
    if (!root || !form || !data) return;
    const variants = JSON.parse(data.textContent);
    const select = form.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const submit = form.querySelector('[data-product-submit]');
    const quantity = form.querySelector('[data-quantity-input]');
    const format = (amount) => (amount / 100).toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency || 'EUR' });
    const update = () => {
      const variant = variants.find((item) => String(item.id) === String(select.value));
      if (!variant) return;
      price.textContent = format(variant.price);
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? (root.dataset.preorder === 'true' ? 'Jetzt reservieren' : 'In den Warenkorb') : 'Ausverkauft';
    };
    select.addEventListener('change', update);
    root.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        quantity.value = Math.max(1, Number(quantity.value || 1) + Number(button.dataset.quantityChange));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  (() => {
    const key = 'mitoru-wishlist';
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    const results = page.querySelector('[data-wishlist-results]');
    const empty = page.querySelector('[data-wishlist-empty]');
    const getState = () => {
      try {
        const value = JSON.parse(localStorage.getItem(key));
        if (Array.isArray(value)) return { products: value, releases: [] };
        return { products: [], releases: [], ...value };
      } catch (_) { return { products: [], releases: [] }; }
    };
    const escape = (value) => String(value).replace(/[&<>'"]/g, (character) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' })[character]);
    const productCard = (product) => '<article class="product-card"><a class="product-card__image" href="' + escape(product.url) + '"><img src="' + escape(product.featured_image || '') + '" alt="' + escape(product.title) + '" loading="lazy"></a><div class="product-card__body"><p class="eyebrow">Gemerktes Produkt</p><h3><a href="' + escape(product.url) + '">' + escape(product.title) + '</a></h3><div class="product-card__footer"><span>' + escape((product.price / 100).toLocaleString(document.documentElement.lang || 'de-DE', { style: 'currency', currency: product.currency || 'EUR' })) + '</span><button class="wishlist-button" type="button" data-wishlist-toggle data-product-handle="' + escape(product.handle) + '" aria-pressed="true">Gemerkt</button></div></div></article>';
    const releaseCard = (release) => '<article class="wishlist-release"><p class="eyebrow">Gemerktes Release</p><h2>' + escape(release.title) + '</h2><p>' + escape(release.status || 'Demnächst') + '</p>' + (release.url ? '<a class="wishlist-release__link" href="' + escape(release.url) + '">Release ansehen →</a>' : '') + '<button class="wishlist-button wishlist-release__button" type="button" data-wishlist-release data-release-id="' + escape(release.id) + '" data-release-title="' + escape(release.title) + '" data-release-url="' + escape(release.url || '') + '" data-release-status="' + escape(release.status || '') + '" aria-pressed="true">Gemerkt</button></article>';
    const render = async () => {
      const state = getState();
      const products = await Promise.all(state.products.map((handle) => fetch('/products/' + encodeURIComponent(handle) + '.js').then((response) => response.ok ? response.json() : null).catch(() => null)));
      const valid = products.filter(Boolean);
      if (valid.length !== state.products.length) localStorage.setItem(key, JSON.stringify({ products: valid.map((product) => product.handle), releases: state.releases }));
      results.innerHTML = valid.map(productCard).join('') + state.releases.map(releaseCard).join('');
      empty.hidden = valid.length + state.releases.length > 0;
    };
    render(); window.addEventListener('mitoru:wishlist-change', render);
  })();

  } catch(e) { console.error(e); }
})();
})();
